module.exports = __webpack_public_path__ + "img/61.527f93aa.jpg";